<template>
	<StoryblokComponent
		v-if="selectedForm"
		v-editable="blok"
		:blok="selectedForm.content"
		:form-id="selectedForm.uuid"
	/>
</template>

<script setup lang="ts">
	import type {FormEmbedStoryblok} from '@/storyblok/types';

	interface Props {
		blok: FormEmbedStoryblok
	}

	const props = defineProps<Props>();
	const selectedForm = computed(() => resolvedStory(props.blok.selectedForm));
</script>
